<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="标题：" prop="title">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="上传文件：" prop="file_path" class="tipsitem">
                <el-upload
                    name="upFile"
                    :action="uploadAction"
                    :show-file-list="true"
                    :limit="1"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload"
                    :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <span class="tips">文件大小不超过20M</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'wtcgEdit',
    mixins: [editutil],
    props: {
        pid: {
            type: Number,
            default() {
                return 0;
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.model.pid = this.pid
                this.resetModel(this.form_name);
                this.fileList = []
            }
        }
    },
    data() {
        return {
            model: {
                pid: '',
                pid1: '',
                pid2: '',
                pid3: '',
                pid4: '',
                title: '',
                file_name: '',
                file_size: '',
                file_size1: '',
                file_path: '',
                suffix: '',
                icon: '',
                add_time: '',
                user_id: '',
                user_name: '',
            },
            getObj:{
                url:'/api/admin/wtcg/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                title: [
                    {required: true, message: '标题不能为空', trigger: 'blur'},
                ],
                file_path: [
                    {required: true, message: '请上传文件', trigger: 'blur'}
                ],
            },
            uploadAction: '/api/admin/workhole/uploadFile',
            fileList: [],
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/wtcg/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                if(this.model.title == ''){
                    this.model.title = res.data.file_name
                }
                this.model.file_name = res.data.file_name
                this.model.file_size = res.data.file_size
                this.model.file_size1 = res.data.file_size1
                this.model.file_path = res.data.file_path
                this.model.suffix = res.data.suffix
                this.model.icon = res.data.icon
            }else{
                this.fileList = []
                this.$msg(res.msg)
            }
        },
        beforeUpload(file){
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('文件大小不能超过 20MB!');
            }
            return isLt20M;
        },
    }
};
</script>